import Icon from '../../Components/Content/Icon';
import { AnimationTimings } from '../../Constants/Animation';
import { Spacing } from '../../Constants/Spacing';
import { Size } from '../../Constants/System';
import styled, { css } from 'styled-components';
import { DisabledBorders, DisabledSchemeKey } from '../../Utility/InputUtils';
import { ValidationState } from './ValidationSection';
export const SizeHeightMap = {
    [Size.small]: '32px',
    [Size.medium]: '40px',
    [Size.large]: '48px',
};
export const SizePaddingMap = {
    [Size.small]: '8px 4px',
    [Size.medium]: '8px 12px',
    [Size.large]: '11px 16px',
};
export const SizeTextSizeMap = {
    [Size.small]: 14,
    [Size.medium]: 14,
    [Size.large]: 16,
};
export const SizeTopMarginMap = {
    [Size.small]: 32,
    [Size.medium]: 32,
    [Size.large]: 36,
};
export const SizeToLabelInsideTopMap = {
    [Size.small]: 8,
    [Size.medium]: 11,
    [Size.large]: 14,
};
export function getBorderColourForValidation(theme, state) {
    switch (state) {
        case ValidationState.None:
            return theme.palette.secondary;
        case ValidationState.Invalid:
            return theme.palette.error;
        case ValidationState.Valid:
            return theme.palette.success;
    }
}
const positionLabelTopCss = (size) => `
	top: -${4 + SizeTextSizeMap[size]}px;
	left: 0;
`;
const positionLabelInsideCss = (size) => `
	top: ${SizeToLabelInsideTopMap[size]}px;
	left: ${Spacing.md};
	pointer-events: none;
`;
const borderThickness = '2px';
export const InputBorderCss = (props) => css `
	// borders
	outline: 0;
	border: ${borderThickness} solid ${getBorderColourForValidation(props.theme, props.$validationState)};
	:hover {
		border: ${borderThickness} solid ${props.theme.palette.accent2};
	}
	:active,
	:focus {
		border: ${borderThickness} solid ${props.theme.palette.brand1};
	}
	${props.$isDisabled ? `color: ${props.theme.schemes.shade5.passive};` : ``}
	${props.$isDisabled ? DisabledBorders(borderThickness) : ''}
`;
export const StyledInputWrapper = styled.div `
	box-sizing: border-box;
	width: 100%;
	position: relative;
	margin-top: ${(props) => (props.$hasLabel ? SizeTopMarginMap[props.$size] : 0)}px;

	input {
		transition: border 200ms ${AnimationTimings.productive};
		height: ${(props) => SizeHeightMap[props.$size]};
		padding: ${(props) => SizePaddingMap[props.$size]};
		background: none;
		color: ${(props) => props.theme.palette.secondary};
		width: 100%;

		font-size: ${(props) => SizeTextSizeMap[props.$size]}px;

		${InputBorderCss}
	}

	label {
		transition: all 200ms ${AnimationTimings.productive};
		font-size: ${(props) => SizeTextSizeMap[props.$size]}px;
		position: absolute;
		${(props) => (props.$labelInsideInput ? positionLabelInsideCss(props.$size) : positionLabelTopCss(props.$size))}

		${(props) => props.$isDisabled
    ? css `
						color: ${props.theme.schemes.shade5.passive};
					`
    : ``}
	}
`;
export const InputInlineIcon = styled(Icon) `
	cursor: pointer;
`;
export const InputInlineActions = styled.div `
	position: absolute;
	right: 0;
	top: 0;
	display: flex;
	height: ${(props) => SizeHeightMap[props.$size]};

	${(props) => props.$hidePointerEvents
    ? css `
					pointer-events: none;
				`
    : ''}

	${InputInlineIcon} {
		height: ${(props) => SizeHeightMap[props.$size]};
		margin-right: ${(props) => props.theme.spacing.md};
		line-height: ${(props) => SizeHeightMap[props.$size]};
		text-align: center;

		&:hover {
			color: ${(props) => props.theme.palette.accent2};
		}

		${(props) => props.disabled
    ? css `
						color: ${props.theme.schemes[DisabledSchemeKey].passive};
						&:hover {
							color: ${props.theme.schemes[DisabledSchemeKey].hover};
						}
					`
    : ''}
	}
`;
//# sourceMappingURL=InputStyles.js.map